import { Tooltip } from 'antd';
import Moveable from 'react-moveable';
import React, { useEffect, useRef, useState, createRef } from 'react'
import "./LayoutSlotSelector.css"

function LayoutSlotsSelector(props) {
    const { size = 60, layoutData, selectedSlotID = -1, onChange = () => { }, disabled = false } = props
    const [currentlyDelectedSlotID, setCurrentlyDelectedSlotID] = useState(-1);
    const [target, setTarget] = React.useState([]);
    const [frame, setFrame] = React.useState({
        translate: [0, 0],
    });


    var data = null

    if ((typeof layoutData) === "string")
        data = JSON.parse(layoutData);
    else
        data = layoutData

    const { width = 0, height = 0, slots = [], background_color = "#000", screenSize = null } = data;
    const slotsRef = useRef(slots.map(() => createRef()));


    useEffect(() => {
        setCurrentlyDelectedSlotID(selectedSlotID)
    }, [selectedSlotID])

    if (!layoutData)
        return null;



    const numWidth = parseFloat(width)
    const numHeight = parseFloat(height)
    const ratio = size / Math.max(numWidth, numHeight);
    const localWidth = numWidth * ratio;
    const localHeight = numHeight * ratio;


    const getSlotName = (data) => {
        const { slot_name = "", slot_id = "" } = data;
        const slotName = (slot_name === "") ? slot_id.replace("slot_", " ") : slot_name;
        return slotName;
    }

    const renderSlots = slots.map((slot, index) => {

        // if (screenSize)
        // ToDo override parent size

        const numSlotX = parseFloat(slot.x)
        const numSlotY = parseFloat(slot.y)
        const numSlotWidth = parseFloat(slot.width)
        const numSlotHeight = parseFloat(slot.height)
        const localSlotWidth = numSlotWidth * ratio;
        const localSlotHeight = numSlotHeight * ratio;
        const localSlotX = numSlotX * ratio;
        const localSlotY = numSlotY * ratio;

        const activeColor = "#4C4D52";
        const inactiveColor = "#dddddd";

        const slotColor = (currentlyDelectedSlotID === slot.slot_id) ? activeColor : inactiveColor
        const fontColor = (currentlyDelectedSlotID === slot.slot_id) ? inactiveColor : activeColor
        const pointerEvent = disabled ? "none" : "inherit"

        var style = { pointerEvents: pointerEvent, cursor: "pointer", padding: "5px", color: fontColor, position: "absolute", left: localSlotX, top: localSlotY, width: localSlotWidth, height: localSlotHeight, backgroundColor: slotColor, zIndex: slot["z-index"] }

        if (currentlyDelectedSlotID === slot.slot_id) {
            style = Object.assign(style, { border: `1px solid ${activeColor}` })
        }
        return <div ref={slotsRef.current[index]} onClick={() => {

            setCurrentlyDelectedSlotID(slot.slot_id);
            onChange(slot.slot_id);

            setTarget(document.querySelector(`.slot_${index}`));
        }} className={`selectable-slot slot_${index}`} style={style}>
            {getSlotName(slot)}
        </div>
    })


    return <div className="center-content" style={{ width: `${size}px`, height: `${size}px`, position: "relative", backgroundColor: "#white", ...props.style }}>
        <div style={{ width: `${localWidth}px`, height: `${localHeight}px`, backgroundColor: background_color, position: "relative" }}>
            {renderSlots}</div>
        {/* <Moveable target={target} draggable={true} resizable={true}
            draggable={true}
            throttleDrag={0}
            onDragStart={({ set }) => {
                set(frame.translate);
            }}
            onDrag={({ target, beforeTranslate }) => {
                frame.translate = beforeTranslate;
                target.style.transform
                    = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
            }}
            onDragEnd={({ target, isDrag, clientX, clientY }) => {
                console.log("onDragEnd", target, isDrag);
            }}
            onResizeStart={({ setOrigin, dragStart }) => {
                setOrigin(["%", "%"]);
                dragStart && dragStart.set(frame.translate);
            }}
            onResize={({ target, width, height, drag }) => {
                const beforeTranslate = drag.beforeTranslate;

                frame.translate = beforeTranslate;
                target.style.width = `${width}px`;
                target.style.height = `${height}px`;
                target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
            }}></Moveable > */}
    </div>
}

export default LayoutSlotsSelector